/**
 * Geogrid Configuration Constants
 * Centralized configuration for geogrid positioning and calculations
 */

export const GEOGRID_CONFIG = {
    // Standard geogrid position (meters above geogrid)
    STANDARD_POSITION_ABOVE_GEOGRID: 0.1,

    // Fallback position calculation (percentage of layer thickness)
    FALLBACK_POSITION_PERCENTAGE: 0.65,

    // Validation limits
    MIN_LAYERS: 1,
    MAX_LAYERS: 6,

    // Default design strain
    DEFAULT_DESIGN_STRAIN: 1,

    // Subgrade bearing capacity safety factor FS: default of every GeoGrid workbook (Circ C49, Rect C45)
    DEFAULT_SAFETY_FACTOR: 3,
} as const;

export type GeogridConfig = typeof GEOGRID_CONFIG;
